import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "@shared/ui/src/fonts/fonts.css";
import "./index.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element with id 'root' was not found.");
}

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
